import { TransactionStatus, TransactionStatusCode } from '@/data/payments';

export enum TransactionType {
  VENDOR_INVOICE = 'vendor_invoice',
  // TODO: consolidate with repositories package type (not available in clearcom)
}

export interface TransactionResponseDto {
  id: string;
  type: TransactionType;
  status: TransactionStatus;
  statusCode: TransactionStatusCode | null;
  paymentDeliveryDate: string | null;
  createdAt: string;
  updatedAt: string;
}
